import angular from 'angular'

angular.module('vend.ui').directive('vdExpandableTrigger', function () {
  return {
    require: '^vdExpandable',
    link($scope, $element, $attrs, vdExpandable) {
      // When this class is applied to a child of a trigger element, the row won't toggle. e.g. on an input field
      // within a toggle row.
      const PREVENT_EXPAND_CLASS = 'vd-prevent-expandable-trigger'

      /**
       * Triggers the toggleExpandedContent method on the parent controller
       */
      function toggleExpanded(e) {
        const triggerElement = angular.element(e.target)
        if (!triggerElement.hasClass(PREVENT_EXPAND_CLASS)) {
          vdExpandable.toggleExpandedContent()
        }
      }

      $element.on('click', toggleExpanded)
      $scope.$on('$destroy', () => $element.off('click', toggleExpanded))
    },
  }
})
